import React from 'react'
import PropTypes from 'prop-types'
import makeStyles from '@mui/styles/makeStyles';
import { Box, Typography, ListItem, List, Checkbox } from '@mui/material'
import { ReactComponent as CheckboxIconSvg } from './Resources/checkbox.svg'
import { ReactComponent as CheckedboxIconSvg } from './Resources/checkedbox.svg'
import { Spinner } from 'packages/eid-ui'

const listItemStyles = makeStyles(() => ({
    root: () => ({
        display: 'flex',
        alignItems: 'center',
        padding: 0,
        // height: props.itemContainerHeight && props.itemContainerHeight,
        marginBottom: '0.5rem',
        marginTop: '0.5rem',
        borderLeft: '3px solid transparent',

        '&:hover': {
            backgroundColor: 'inherit',
        },
        '& span': {
            paddingTop: '0',
            paddingBottom: '0',
        },
        '& p': {
            width: '100%',
            padding: '0 0.5rem',

            borderRadius: '0.5rem',
            '&:hover': {
                backgroundColor: '#f1f1f4',
            },
        },
        '& .search-highlight2': {
            color: '#950167',
            fontWeight: 600,
            textDecoration: 'underline',
        },
    }),
}))
const useStyles = makeStyles(() => ({
    root: {
        width: '100%',
    },
    activeListItem: {
        background: '#fafcff',
        borderLeft: '0.3rem solid #307fc1',
        color: '#000 !important',
        '& .MuiBox-root': {
            '& p': {
                background: '#fff !important',
                color: '#000 !important',
            },
        },
    },
}))
const checkboxStyles = makeStyles({
    root: {
        '&:hover': {
            backgroundColor: 'transparent !important',
        },
    },
})

const highlight = (text, searchKey) => {
    searchKey = new RegExp('(' + searchKey + ')', 'gi')
    return text.split(searchKey).map((o, i) =>
        i % 2 === 1 ? (
            <span className="search-highlight2" key={i}>
                {o}
            </span>
        ) : (
            o
        ),
    )
}

export default function CheckboxList(props) {
    const {
        fontSize,
        fontColor,
        itemContainerHeight,
        handleToggle,
        checked,
        loading,
        dataList,
        highlightText,
        fallbackMessage,
        highlightSelected = false,
    } = props

    const classes = useStyles()
    const itemClasses = listItemStyles({ itemContainerHeight })
    const checkboxClasses = checkboxStyles()

    const isChecked = (item) => {
        return !item ? false : Boolean(checked.find((c) => c.id === item.id))
    }
    return loading ? (
        <Box
            width="100%"
            height="100%"
            display="flex"
            justifyContent="center"
            padding="2rem"
            marginLeft="-1rem"
        >
            <Spinner />
        </Box>
    ) : (
        dataList && (
            <List className={classes.root}>
                {dataList.length === 0 && <>{fallbackMessage}</>}
                {dataList.map((item, index) => {
                    const labelId = `checkbox-list-label-${item.friendlyName}`

                    return (
                        <ListItem
                            key={index}
                            role={undefined}
                            button
                            onClick={() => handleToggle(item)}
                            classes={itemClasses}
                            className={
                                highlightSelected && isChecked(item)
                                    ? classes.activeListItem
                                    : ''
                            }
                        >
                            <Box display="flex" alignItems="center">
                                <Box>
                                    <Checkbox
                                        edge="start"
                                        color="primary"
                                        classes={checkboxClasses}
                                        icon={
                                            <Box
                                                display="flex"
                                                alignItems="center"
                                            >
                                                <CheckboxIconSvg></CheckboxIconSvg>
                                            </Box>
                                        }
                                        checkedIcon={
                                            <Box
                                                display="flex"
                                                alignItems="center"
                                            >
                                                <CheckedboxIconSvg></CheckedboxIconSvg>
                                            </Box>
                                        }
                                        checked={isChecked(item)}
                                        tabIndex={-1}
                                        disableRipple
                                        disableFocusRipple
                                        inputProps={{
                                            'aria-labelledby': labelId,
                                        }}
                                    />
                                </Box>
                                <Box>
                                    <Typography
                                        variant="body2"
                                        style={{
                                            color: fontColor,
                                            fontSize: fontSize
                                                ? fontSize
                                                : '1.4rem',
                                            wordBreak: 'break-word',
                                            wordWrap: 'break-word',
                                            overflow: 'auto',
                                        }}
                                    >
                                        {highlightText && highlightText.length
                                            ? highlight(
                                                  item.friendlyName,
                                                  highlightText,
                                              )
                                            : item.friendlyName}
                                    </Typography>
                                </Box>
                            </Box>
                        </ListItem>
                    )
                })}
            </List>
        )
    )
}

CheckboxList.propTypes = {
    fontSize: PropTypes.string,
    fontColor: PropTypes.string,
    itemContainerHeight: PropTypes.any,
    handleToggle: PropTypes.func,
    checked: PropTypes.array,
    dataList: PropTypes.array,
    highlightText: PropTypes.any,
    fallbackMessage: PropTypes.any,
}

CheckboxList.defaultProps = {}
